var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-headers tw-flex tw-bg-blue-400 tw-px-4"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }